import React from 'react'
import { ROUTES } from '../../routes'
import { Link } from 'react-router-dom'
import cn from 'classnames'
import styles from './index.module.scss'

export default function HaulerSMS () {
  return (
    <div className={cn(styles.listItem, 'dis-list-item')}>
      <div>
        <div className={styles.title}>Customer SMS</div>
        <div className={cn(styles.description, styles.mdText)}>
          Global setup for SMS Communication to Customers.
        </div>
      </div>

      <Link
        to={ROUTES.smsSettings}
        className={cn(styles.btnLink, 'dis-btn dis-btn-sm dis-btn-primary-lt')}>
        <span className={styles.mdText}>SMS Settings</span>
      </Link>
    </div>
  )
}
